export const
    NOTIFICATION_SHOW = "NOTIFICATION_SHOW",
    NOTIFICATION_HIDE = "NOTIFICATION_HIDE";

export function notificationErrorShow(message) {
    return {
        type: NOTIFICATION_SHOW,
        message,
        messageType: "error"
    };
}

export function notificationSuccessShow(message) {
    return {
        type: NOTIFICATION_SHOW,
        message,
        messageType: "success"
    };
}

export function notificationHide() {
    return {
        type: NOTIFICATION_HIDE
    };
}



// WEBPACK FOOTER //
// ./src/actions/notification.actions.ts